export const COLOR_LOCKED = ['Live', 'BackToLive', 'Csa6', 'Csa12', 'Csa16', 'Csa18'];
